import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';

import csrfObject from '../../modules/csrf';

const propTypes = {
  courseId: PropTypes.number.isRequired,
  dir: PropTypes.string,
  endpoint: PropTypes.string.isRequired,
  strings: PropTypes.shape({
    buttonCancel: PropTypes.string,
    buttonSubmit: PropTypes.string,
    placeholder: PropTypes.string,
    successMessage: PropTypes.string,
    trigger: PropTypes.string,
  }).isRequired,
  questionId: PropTypes.number.isRequired,
};

const StepMessage = ({
  courseId,
  dir = null,
  endpoint,
  strings,
  questionId,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [sent, setSent] = useState(false);
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);

  const handleSubmit = event => {
    event.preventDefault();
    setBusy(true);
    $.post(endpoint, {
      body: message,
      course_id: courseId,
      context_type: 'Question',
      context_id: questionId,
      ...csrfObject(),
    }).done(() => {
      setBusy(false);
      setSent(true);
    });
  };

  useEffect(() => {
    setSent(false);
    setMessage('');
    setExpanded(false);
  }, [questionId]);

  return (
    <div dir={dir} className="step-message">
      {!expanded && !sent && (
        <button
          className="step-message__trigger"
          data-test="newMessageButton"
          onClick={() => setExpanded(true)}
          type="button"
        >
          {strings.trigger}
        </button>
      )}

      {expanded && !sent && (
        <form
          onSubmit={handleSubmit}
        >
          <textarea
            className="step-message__field"
            // Force left-to-right until we decide how we want to handle messaging
            // in different languages (specifically with different dirs)
            dir="ltr"
            onChange={event => setMessage(event.target.value)}
            placeholder={`+ ${strings.placeholder}`}
            value={message}
          />
          <div className="step-message__buttons">
            <div>
              <button
                disabled={busy || message === ''}
                type="submit"
              >
                {strings.buttonSubmit}
              </button>

              <button
                disabled={busy}
                onClick={() => setExpanded(false)}
                type="button"
              >
                {strings.buttonCancel}
              </button>
            </div>
          </div>
        </form>
      )}

      {sent && (
        <p>
          {strings.successMessage}
        </p>
      )}
    </div>
  );
};

StepMessage.propTypes = propTypes;

export default StepMessage;
